import { styled, TextField as MuiTextField } from '@mui/material';

export const AutoCompleteRoot = styled('div')(() => ({
  flex: 1,
  minWidth: '100%',
  maxWidth: '100%',
  marginBottom: 8,
  '& .MuiAutocomplete-root': {
    width: '100%',
    padding: 0,

    '& .MuiAutocomplete-input': {
      boxSizing: 'content-box!important',
    },

    '& .MuiOutlinedInput-root': {
      padding: '2px 60px 2px 5px',
    },
  },

  '& .MuiAutocomplete-root .MuiTextField-root': {
    height: 'initial',
  },
}));

export const TextField = styled(MuiTextField)(() => ({
  height: 42,
  '& .MuiInputBase-root': {
    height: 'initial',
    gap: 2,
  },

  '& .MuiOutlinedInput-root .MuiChip-root': {
    height: 30,
    marginTop: 0,
  },
}));
